module.exports = __webpack_public_path__ + "media/images/people-default-8a475a8c91f95cedcc586575970043e0.png";